import * as React from 'react'
import EventBanner from 'Widgets/EventBanner'
import Posts from 'Widgets/Posts'
import useEventStore from 'Store/eventStore'
import { Button, Container, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import useFileStore from 'Store/fileStore'
import usePostStore from 'Store/postStore'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import { ThemeProvider } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import eventTheme from 'Settings/themes/eventTheme'
import Hero from 'Components/Hero'

export default function Dashboard() {
      const { t } = useTranslation()
      const { triggerFileInput } = useFileStore()
      const theme = useTheme()

      const loading = useEventStore((state) => state.loading)
      const event = useEventStore((state) => state.event)
      const unsubscribe = useEventStore((state) => state.unsubscribe)
      const getSubscriptions = useEventStore((state) => state.getSubscriptions)
      const getSubscribers = useEventStore((state) => state.getSubscribers)
      const setEvent = useEventStore((state) => state.setEvent)
      const posts = usePostStore((state) => state.posts)

      const [subscribers, setSubscribers] = React.useState([])

      React.useEffect(() => {
            // if (!loading) {
            fetchData()
            // }
      }, [])

      React.useEffect(() => {
            if (event) {
                  getSubscribersAsync(event)
            }
      }, [event])

      const getSubscribersAsync = async (event) => {
            const subs = await getSubscribers(event.id)
            setSubscribers(subs)
      }

      const fetchData = async () => {
            if (event) {
                  //   fetchEventData(event.unique_id)
            } else {
                  const subs = await getSubscriptions()
                  if (subs.length > 0) {
                        await setEvent(subs[subs.length - 1].unique_id)
                        // fetchEventData(subs[0].unique_id)
                  }
            }
      }

      if (!event) return null

      return (
            <ThemeProvider theme={() => eventTheme(event.config)}>
                  <Container maxWidth="lg" sx={{ padding: '0' }}>
                        <EventBanner />
                        <Hero />
                        <Button
                              size="large"
                              fullWidth
                              onClick={() => triggerFileInput()}
                              variant="contained"
                              color="primary"
                              endIcon={<ChevronRightIcon />}
                        >
                              {t('upload')}
                        </Button>
                        <Posts />
                  </Container>
            </ThemeProvider>
      )
}
